import OriginationEntity from '../entities/Origination.Entity';
import { apiGet } from '../support/helpers/ApiConnection.Helper';

export default function getOriginations(abortSignal: AbortSignal): Promise<Array<OriginationEntity>> {    
    return apiGet<Array<OriginationEntity>>('/origination',abortSignal);
}
